import { ReactElement } from "react";
import Button, { TButtonVariant } from "../../../ui/button";
import { ComplexAnimatedModal } from "../../../ui/modal/ComplexAnimatedModal";
import styles from "./styles.module.scss";

interface IConfirmModal {
  opened: boolean;
  title: string;
  text: string;
  loading?: boolean;
  offsetY: number;
  onClose: (value: boolean) => void;
  onClickLeft?: () => void;
  onClickRight: () => void;
  labelLeft?: string;
  labelRight?: string;
  variantLeft?: TButtonVariant;
  variantRight?: TButtonVariant;
  children?: ReactElement;
}

const ConfirmModal = ({
  labelLeft,
  labelRight,
  variantRight,
  variantLeft,
  title,
  text,
  opened,
  loading,
  children,
  offsetY,
  onClose,
  onClickLeft,
  onClickRight,
}: IConfirmModal) => {
  const handleClickLeft = () => {
    if (onClickLeft) {
      onClickLeft();
    } else {
      onClose(false);
    }
  };

  return (
    <ComplexAnimatedModal opened={opened} onClose={() => onClose(false)} offsetY={offsetY}>
      <div className={styles.confirmModal__container}>
        <div className={styles.confirmModal__title}>{title}</div>
        <div className={styles.confirmModal__text}>{text}</div>
        {children && (
          <div className={styles.confirmModal__children}>{children}</div>
        )}
        <div className={styles.confirmModal__buttons}>
          <Button
            label={labelLeft ?? "Отменить"}
            variant={variantRight ?? "gray"}
            onClick={handleClickLeft}
          />
          <Button
            loading={loading}
            label={labelRight ?? "Да"}
            variant={variantLeft ?? "default"}
            onClick={onClickRight}
          />
        </div>
      </div>
    </ComplexAnimatedModal>
  );
};

export default ConfirmModal;
